import React from "react";
import Helmet from "react-helmet";
var DealInfoSEO = function (_a) {
    var deal = _a.deal, pageTitle = _a.pageTitle;
    var template = "%s " + (pageTitle ? "| " + pageTitle : "");
    return (React.createElement(Helmet, { titleTemplate: template },
        React.createElement("title", null, deal === null || deal === void 0 ? void 0 : deal.header)));
};
DealInfoSEO.defaultProps = {
    pageTitle: "Perkbox"
};
export default DealInfoSEO;
